import { render, staticRenderFns } from "./contractsTable.vue?vue&type=template&id=08bbca43&scoped=true&"
import script from "./contractsTable.vue?vue&type=script&lang=js&"
export * from "./contractsTable.vue?vue&type=script&lang=js&"
import style0 from "./contractsTable.vue?vue&type=style&index=0&id=08bbca43&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bbca43",
  null
  
)

export default component.exports